// extracted by css-extract-rspack-plugin
export default {"label":"blockedPublishersSetting_label__qabAc"};